import { StatusState } from "store/types";
import { VolunteerState } from "./volunteers.types";

export const initialState: VolunteerState = {
  data: [],
  status: StatusState.IDLE,
  error: null,
};